import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomLineGraph from "./CustomLineChart";
import styles from "./chartStyle.module.css";

type SalesDataType = { name: string; value: number };

type SaleProps = {
  newOrdersData: SalesDataType[];
  newUsersData: SalesDataType[];
  newOrdersValueData: SalesDataType[];
  currentMonthName?: React.ReactChild;
  orderNum?: number;
  usersNum?: number;
  orderVal?: string;
};

const SalesReport: React.FC<SaleProps> = ({
  newOrdersData,
  newUsersData,
  newOrdersValueData,
  currentMonthName,
  orderNum,
  orderVal,
  usersNum,
}) => {
  const [tabValue, setTabValue] = useState(0);
  const totalTabs = 3;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      const nextTabValue = (tabValue + 1) % totalTabs;
      setTabValue(nextTabValue);
    }, 300000);

    return () => {
      clearInterval(intervalId);
    };
  }, [tabValue]);

  return (
    <Box>
      <Tabs
        value={tabValue}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        className={`${styles.tabs}`}
      >
        <Tab
          label={
            <div
              className={`${styles.tab} ${
                tabValue === 0 ? styles.tab__active : ""
              }`}
            >
              <span className={`${styles.tab__name}`}>New Orders</span>
              <span className={`${styles.tab__number}`}>{orderNum}</span>
            </div>
          }
        />
        <Tab
          label={
            <div
              className={`${styles.tab} ${
                tabValue === 1 ? styles.tab__active : ""
              }`}
            >
              <span className={`${styles.tab__name}`}>New Users</span>
              <span className={`${styles.tab__number}`}>{usersNum}</span>
            </div>
          }
        />
        <Tab
          label={
            <div
              className={`${styles.tab} ${
                tabValue === 2 ? styles.tab__active : ""
              }`}
            >
              <span className={`${styles.tab__name}`}>New Orders Value</span>{" "}
              <span className={`${styles.tab__number}`}>{orderVal}</span>
            </div>
          }
        />
      </Tabs>
      <Box>
        {tabValue === 0 && <CustomLineGraph data={newOrdersData} />}
        {tabValue === 1 && <CustomLineGraph data={newUsersData} />}
        {tabValue === 2 && <CustomLineGraph data={newOrdersValueData} price />}
      </Box>
    </Box>
  );
};
export default SalesReport;
